import { ActionContext, Module } from 'vuex'
import { SeoResellingService, ProductRebillingService } from '../services'
import { SeoState, RootState } from '../store/state_models'

import get from "lodash-es/get"
import set from "lodash-es/set"

export const seo: Module<SeoState, RootState> = {
  namespaced: true,
  state: {
    isSeoEnabled: undefined,
    trialSeoList: {},
    seoSettings: {},
    locationSeoEnabling: {},
    seoResellingSettings: {},
  },
  getters: {
    getTrialConversations: (state: SeoState) => {
      return (locationId: string,agentId: string) =>
        get(state.trialSeoList, [locationId,agentId])
    },
    getSeoSettings: (state: SeoState) => {
      return (locationId: string) => get(state.seoSettings, locationId)
    },
    getSeoResellingSettings: (state: SeoState) => {
      return (params: { locationId: string; employeeId: string }) => {
        return get(state.seoResellingSettings, params.locationId)?.[params.employeeId]
      }
    },
  },
  mutations: {
    updateSeoList: (
      state: SeoState,
      params: { message: { [key: string]: any }; locationId: string, agentId: string,  thumbVote?:string, index?:any, selectedIntent?:string }
      ) => {
        if (state.trialSeoList[params.locationId]) {
          if(state.trialSeoList[params.locationId][params.agentId]){
            if(params.thumbVote){
              state.trialSeoList[params.locationId][params.agentId].messageList[params.index]['thumbVote']= params.thumbVote
            } 
            if(params.message) {
              state.trialSeoList[params.locationId][params.agentId].messageList.push(params.message)
            }
            if(params.selectedIntent){
              state.trialSeoList[params.locationId][params.agentId].selectedIntent = params.selectedIntent
            }
          }
          else{
            state.trialSeoList[params.locationId][params.agentId] = {messageList: [], selectedIntent: ''}
            if(params.message)
              state.trialSeoList[params.locationId][params.agentId].messageList.push(params.message)
            if(params.selectedIntent)
              state.trialSeoList[params.locationId][params.agentId].selectedIntent = params.selectedIntent
          }
        } else {
          state.trialSeoList = set(
            state.trialSeoList,
            params.locationId,
            {[params.agentId]: {messageList: [], selectedIntent: ''}}
          )
          if(params.message)
            state.trialSeoList[params.locationId][params.agentId].messageList.push(params.message)
          if(params.selectedIntent)
            state.trialSeoList[params.locationId][params.agentId].selectedIntent = params.selectedIntent
        }
  
      },
    resetSeoList: (
      state: SeoState,
      params: { locationId: string, agentId: string }
    ) => {
      state.trialSeoList[params.locationId][params.agentId].messageList = []
      state.trialSeoList[params.locationId][params.agentId].selectedIntent = ''
    },
    updateSeoEnabled:(state: SeoState,
      payload: { value:boolean }) => {
        state.isSeoEnabled = payload.value
    },
    updateSeoSettings: (state: SeoState,
      payload: {data: any, locationId: string}) => {
        state.seoSettings[payload.locationId] = payload.data
        window.localStorage.seoSetting = JSON.stringify(payload.data)
    },
    updateSeoResellingSettings: (state: SeoState, payload: { data: any; locationId: string }) => {
      state.seoResellingSettings[payload.locationId] = {
        ...state.seoResellingSettings[payload.locationId],
        ...payload.data,
      }
    },
    updateLocationWiseEnabling: (state:SeoState, payload:{locationId: string, enabled: boolean}) => {
      state.locationSeoEnabling[payload.locationId] = payload.enabled
    }
  },
  actions: {
    addTrialMessage: (
      context: ActionContext<SeoState, RootState>,
      payload: { message: { [key: string]: any }; locationId: string; agentId: string; }
    ) => {
      context.commit('updateSeoList', payload)
    },
    resetSeo: (
      context: ActionContext<SeoState, RootState>,
      payload: { locationId: string, agentId: string; }
    ) => {
      context.commit('resetSeoList', payload)
    },
    changeSeoEnabling: (context: ActionContext<SeoState, RootState>,
      payload: { value:boolean }) =>{
        context.commit('updateSeoEnabled', payload)
      },
    updateTrialAuditing: (
      context: ActionContext<SeoState, RootState>,
      payload: { thumbVote: string, agentId: string; }    // 'up' 'down'
    ) => {
      context.commit('updateSeoList', payload)
    },
    updateSelectedIntent: (
      context: ActionContext<SeoState, RootState>,
      payload: { selectedIntent: string, agentId: string; }
    ) => {
      context.commit('updateSeoList', payload)
    },

    updateSeoSettings: (
      context: ActionContext<SeoState, RootState>,
      payload: { data: any, locationId: string }
    ) => {
      context.commit('updateSeoSettings', payload)
    }, 
    updateSeoResellingSettings: (context: ActionContext<SeoState, RootState>,
      payload: { data: any, locationId: string, employeeId: string }) => {
        context.commit('updateSeoResellingSettings', payload)
      },
    changedLocationEnabling :( context: ActionContext<SeoState, RootState>,
      payload: { locationId: string, enabled: boolean }) => {
        context.commit('updateLocationWiseEnabling',payload)
      },
    async getProduct() {
      try {
        const res = await SeoResellingService.getProductConfiguration()
        return Promise.resolve(res)
      } catch(error) {
        return Promise.reject(error)
      }
    },
    async getCompanySubscriptions(context: ActionContext<SeoState, RootState>) {
      try {
        const companyId =  context.rootState?.company.company.id as string
        const res = await SeoResellingService.getCompanySubscriptions(companyId)

        let locationSubscriptions = res.filter((item) => item.productCode === "seo_search_atlas")
        return Promise.resolve(locationSubscriptions)
      } catch(error) {
        return Promise.reject(error)
      }
    },
    async getLocationSubscriptions(context: ActionContext<SeoState, RootState>) {
      try {
        const locationId = context.rootState?.locations.currentLocation.id as string
        const res = await SeoResellingService.getLocationSubscriptions(locationId)
        let locationSubscriptions = res.filter((item) => item.productCode === "seo_search_atlas" && item.paymentStatus == "COMPLETE")

        return Promise.resolve(locationSubscriptions)
      } catch(error) {
        return Promise.reject(error)
      }
    },
    async fetchSeoOptInForLocation(context: ActionContext<SeoState, RootState>, payload: { entityId: string }) {
      const entityId = payload.entityId
      if (!entityId) return;
      const isSeoEnabledForLocation = context.state?.locationSeoEnabling[entityId];
      if (isSeoEnabledForLocation !== undefined && isSeoEnabledForLocation !== null) {
        return isSeoEnabledForLocation;
      }
      let response = await ProductRebillingService.getByProduct(entityId, 'LOCATION', 'seo', true);
      if (response) {
        await context.commit('updateLocationWiseEnabling', { locationId: entityId, enabled: response.productOptIn });
        return response.productOptIn;
      }
      return true;
    }
  },
}
